import LayerSelector from "./LayerSelector";
import * as labels from "config.labels";
import { connect } from "react-redux";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as rateChangeSlice from "store/rateChange";
import * as pricingSelectors from "store/selectors/pricing/pricingSelectors";

const CurrentLayerSelector = ({ loading, layers, selectedId, onSelectId }) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");

  const title = translateLabel(
    labels.RATE_CHANGE_CURRENT_LAYER_SELECTOR_TITLE,
    {
      default: "Layer",
    }
  );
  const subtitle = translateLabel(
    labels.RATE_CHANGE_CURRENT_LAYER_SELECTOR_SUBTITLE,
    {
      default: "Select which layer you are looking at from this program.",
    }
  );

  return (
    <LayerSelector
      title={title}
      subtitle={subtitle}
      loading={loading}
      layers={layers}
      selectedId={selectedId}
      onSelectId={onSelectId}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    loading: false,
    layers: pricingSelectors.selectResolvedLayers(state),
    selectedId: rateChangeSlice.selectRateChange(state)?.activeLayerId ?? null,
  };
};

const mapDispatchToProps = {
  onSelectId: rateChangeSlice.updateRateChangeItem("activeLayerId"),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrentLayerSelector);
